// Unlike toggle_submit_controller, this toggle does NOT submit a form on change.
// It updates the switch appearance in-place and defers persistence to the parent form's Save button.
// Use this for toggles embedded within an edit form that should be saved alongside other fields.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['track', 'dot', 'label']
  static values = { on: String, off: String, confirmOff: String, confirmOn: String }

  async change(event) {
    const checkbox = event.target
    const togglingOff = !checkbox.checked
    const confirmMessage = togglingOff ? this.confirmOffValue : this.confirmOnValue

    if (confirmMessage) {
      checkbox.checked = !checkbox.checked

      const confirmEl = document.querySelector('[data-controller~="confirm"]')
      const confirmController = this.application.getControllerForElementAndIdentifier(confirmEl, 'confirm')
      if (!confirmController) return

      const confirmed = await confirmController.request({ message: confirmMessage })
      if (!confirmed) return

      checkbox.checked = !checkbox.checked
    }

    const checked = checkbox.checked
    this.labelTarget.textContent = checked ? this.onValue : this.offValue
    this.trackTarget.classList.toggle('bg-black-1000', checked)
    this.trackTarget.classList.toggle('bg-black-200', !checked)
    this.dotTarget.classList.toggle('right-2', checked)
    this.dotTarget.classList.toggle('left-2', !checked)
  }
}
